export function transliterateCyrillic(
  input: string = '',
  caseInsensitive = true,
): string {
  const map: Record<string, string> = {
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'g',
    д: 'd',
    е: 'e',
    ё: 'yo',
    ж: 'zh',
    з: 'z',
    и: 'i',
    й: 'y',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'h',
    ц: 'ts',
    ч: 'ch',
    ш: 'sh',
    щ: 'sch',
    ъ: '',
    ы: 'y',
    ь: '',
    э: 'e',
    ю: 'yu',
    я: 'ya',
  };

  if (caseInsensitive) {
    input = input.toLowerCase();
  }

  let result = '';

  for (const ch of input) {
    const isUpper = ch.toUpperCase() === ch && ch.toLowerCase() !== ch;
    const lowerCh = ch.toLowerCase();
    if (map[lowerCh]) {
      const mapped = map[lowerCh];
      result += isUpper && !caseInsensitive ? mapped.toUpperCase() : mapped;
    } else {
      result += ch;
    }
  }

  // Replace unwanted chars except dash, underscore, space → all become underscores
  result = result.replace(/[^a-zA-Z0-9_\- ]/g, '_');
  // Convert dashes to underscores
  result = result.replace(/-/g, '_');
  // Replace spaces with underscores
  result = result.replace(/ /g, '_');

  // If caseInsensitive, force output to lowercase
  return caseInsensitive ? result.toLowerCase() : result;
}